import * as angular from "angular";
import { CanvasserTrackingDataProvider } from "../../../data-provider/canvasser-tracking.dp";
import { DashboardWidgetFilter } from "../../../models/dashboard-widget-filter.model";
import { PermissionCheck } from "../../../shared/permission";
import { DialogUtils } from "../../../helper/dialog.helper";
import { User } from "../../../models/user.model";
import { Dashboard } from "../../../models/dashboard.model";

let CanvasserTrackingWidgetComponent = {
    selector: "vcCanvasserTrackingWidget",
    templateUrl:
        "/angular/components/canvasser-tracking/widget/canvasser-tracking-widget.component.html",
    bindings: {
        filter: "=",
        dashboard: "=",
        mode: "=?",
    },
    controller: class CanvasserTrackingWidgetController {
        // * bindings for typescript compiler *
        public filter: DashboardWidgetFilter;
        public dashboard: Dashboard;
        public mode?: string;
        // ************************************

        public dataProvider: CanvasserTrackingDataProvider;
        public permissionProvider: PermissionCheck;

        public users?: User[] = null;
        public markers?: object[] = [];

        constructor(
            $scope: any,
            __env: any,
            PermissionCheck: PermissionCheck,
            CanvasserTrackingDataProvider: CanvasserTrackingDataProvider
        ) {
            this.dataProvider = CanvasserTrackingDataProvider;
            this.permissionProvider = PermissionCheck;

            $scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (oldValue && newValue !== oldValue) {
                        this.users = null;
                        this.dataProvider.clearMarkers(this.markers);
                        this.loadData();
                    }
                },
                true
            );
        }

        $onInit() {
            this.loadData();
        }

        loadData() {
            this.dataProvider.filter = this.filter;
            this.dataProvider.getAllUsers(this.filter).then((users: User[]) => {
                this.users = users;
                this.dataProvider.setMarkers(this.markers, this.users);
            });
        }
    },
};

angular
    .module("canvasserTracking")
    .component(
        CanvasserTrackingWidgetComponent.selector,
        CanvasserTrackingWidgetComponent
    );
